// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"429":"73596a58","7560":"9f012b4b"}[chunkId] + ".chunk.css";
};